import React from 'react';
import { AlertCircle, Video, Mic } from 'lucide-react';

function PermissionsAlert() {
  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
      <div className="flex items-start">
        <AlertCircle className="h-5 w-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-semibold text-blue-800 mb-1">
            Permisos de Cámara y Micrófono Requeridos
          </h3>
          <p className="text-xs text-blue-700 mb-2">
            Para usar videollamadas, debes permitir el acceso a tu cámara y micrófono.
          </p>
          <div className="flex items-center gap-4 text-xs text-blue-600">
            <div className="flex items-center gap-1">
              <Video className="h-4 w-4" />
              <span>Cámara</span>
            </div>
            <div className="flex items-center gap-1">
              <Mic className="h-4 w-4" />
              <span>Micrófono</span>
            </div>
          </div>
          <p className="text-xs text-blue-600 mt-2">
            El navegador te pedirá permiso cuando inicies una videollamada.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PermissionsAlert;
